import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRecebimento({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'recebimento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRecebimento({ payload }) {
  try {
    const { desc_codigo, params } = payload;

    yield call(api.delete, `recebimento/${desc_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaorecebimento, params } = payload;

    yield call(api.post, 'recebimento', operacaorecebimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    //history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { desc_codigo } = payload;

    const { data } = yield call(api.get, `recebimento/${desc_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaorecebimento, params } = payload;

    yield call(api.put, 'recebimento', operacaorecebimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/recebimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'recebimento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaorecebimento/RECEBIMENTO_IN_REQUEST',
    requestOperacaoRecebimento
  ),
  takeLatest(
    '@operacaorecebimento/DELETE_RECEBIMENTO',
    deleteOperacaoRecebimento
  ),
  takeLatest('@operacaorecebimento/SUCCESS_REMOVE', requestOperacaoRecebimento),
  takeLatest('@operacaorecebimento/STORE_RECEBIMENTO', store),
  takeLatest('@operacaorecebimento/FIND_RECEBIMENTO', find),
  takeLatest('@operacaorecebimento/UPDATE_RECEBIMENTO', update),
  takeLatest('@operacaorecebimento/RECORD_FILTERING', applyedFilters),
]);
